module.exports = __webpack_public_path__ + "static/commercetools_logo-e0767c2ef052048dbbded07d40dc661b.svg";